import { render, staticRenderFns } from "./VideoScopeBanner.vue?vue&type=template&id=230ecb7c&scoped=true&"
import script from "./VideoScopeBanner.vue?vue&type=script&lang=js&"
export * from "./VideoScopeBanner.vue?vue&type=script&lang=js&"
import style0 from "./VideoScopeBanner.vue?vue&type=style&index=0&id=230ecb7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230ecb7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpandTransition,VIcon})
